import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import '../../timeSheet.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faFilePen, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { faCircleCheck, faCircleDown, faCircleXmark, faEye } from '@fortawesome/free-regular-svg-icons';
import { TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Modal } from 'react-bootstrap';

function ApproveProjectTimesheet() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showApprove, setshowApprove] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCloseApprove = () => setshowApprove(false);
    const handleshowApprove = () => setshowApprove(true);
    const [selectedDate, setSelectedDate] = useState(null);
    const [weekRange, setWeekRange] = useState("");

    const handleDateChange = (date) => {
        setSelectedDate(date);

        if (date) {
        //   const day = date.day(); // 0 (Sunday) to 6 (Saturday)
        const sunday = date.startOf("week"); // Sunday
        const saturday = sunday.add(6, "day"); // Saturday

        const formattedRange = `${sunday.format("DD/MM/YYYY")} to ${saturday.format("DD/MM/YYYY")}`;
        setWeekRange(formattedRange);
        } else {
        setWeekRange("");
        }
    };

  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Timesheet Management</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Timesheet Management</span>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="flex-end" alignItems="center" className="my-4">
                    <Grid size={{ sm:6,xs: 12 }} container alignItems="center" className="gap-3 regiter_inputs i94validateinput">
                        <Grid container>
                            <div className='project_showstart'><span><b>Project : </b>HR Training</span></div>
                        </Grid>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                className="date_pickermux date_selectsheet"
                                value={selectedDate}
                                onChange={handleDateChange}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                        {weekRange && <input style={{width:"max-content"}} value={weekRange} disabled />}
                    </Grid>
                    <Grid size={{ sm:6,xs: 12 }} container justifyContent="flex-end" className="gap-3">
                        <button className='download_csvbtndatatable'>Download CSV<FontAwesomeIcon className='ps-2' icon={faCircleDown} /></button>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container className="mt-4 timesheet_table">
                    <table className="table table-bordered" style={{minWidth:"1700px"}}>
                        <thead>
                            <tr>
                                <th><input type='checkbox'/></th>
                                <th className='text-start'>EMPLOYEE NAME</th>
                                <th>NOTES</th>
                                <th>ATTACHMENTS</th>
                                <th>STATUS</th>
                                <th>ACTIONS</th>
                                <th className='blue_bgcell_sheet'><span className='d-flex flex-column'>SUN<small>12/01</small></span></th>
                                <th><span className='d-flex flex-column'>MON<small>12/02</small></span></th>
                                <th><span className='d-flex flex-column'>TUE<small>12/03</small></span></th>
                                <th><span className='d-flex flex-column'>WED<small>12/04</small></span></th>
                                <th><span className='d-flex flex-column'>THU<small>12/05</small></span></th>
                                <th><span className='d-flex flex-column'>FRI<small>12/06</small></span></th>
                                <th className='blue_bgcell_sheet'><span className='d-flex flex-column'>SAT<small>12/07</small></span></th>
                                <th>TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>Matthew</span>
                                </td>
                                <td><button className='timesheet_editbtn'><FontAwesomeIcon icon={faFilePen} /></button></td>
                                <td>
                                    <button className='timesheet_viewbtn'><FontAwesomeIcon icon={faEye} /></button>
                                </td>
                                <td>
                                    <span className='rejected_timesheet'><FontAwesomeIcon icon={faCircleXmark} /> Rejected</span>
                                </td>
                                <td>
                                    <div className='d-flex justify-content-center gap-3 action_sheetbtntable'>
                                        <button className='green_sheetaction' onClick={handleshowApprove}><FontAwesomeIcon icon={faCircleCheck} /></button>
                                        <button className='red_sheetaction' onClick={handleShow}><FontAwesomeIcon icon={faXmark} /></button>
                                    </div>
                                </td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td>40.00</td>
                            </tr>
                            <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>Charles</span>
                                </td>
                                <td><button className='timesheet_editbtn'><FontAwesomeIcon icon={faFilePen} /></button></td>
                                <td>
                                    <button className='timesheet_viewbtn'><FontAwesomeIcon icon={faEye} /></button>
                                </td>
                                <td>
                                    <span className='submitted_timesheet'><FontAwesomeIcon icon={faCircleCheck} /> Submitted</span>
                                </td>
                                <td>
                                    <div className='d-flex justify-content-center gap-3 action_sheetbtntable'>
                                        <button className='green_sheetaction'><FontAwesomeIcon icon={faCircleCheck} /></button>
                                        <button className='red_sheetaction'><FontAwesomeIcon icon={faXmark} /></button>
                                    </div>
                                </td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td>40.00</td>
                            </tr>
                            <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>Kenneth</span>
                                </td>
                                <td><button className='timesheet_editbtn'><FontAwesomeIcon icon={faFilePen} /></button></td>
                                <td>
                                    <button className='timesheet_viewbtn'><FontAwesomeIcon icon={faEye} /></button>
                                </td>
                                <td>
                                    <span className='approved_timesheet'><FontAwesomeIcon icon={faCircleCheck} /> Approved</span>
                                </td>
                                <td>
                                    <div className='d-flex justify-content-center gap-3 action_sheetbtntable'>
                                        <button className='green_sheetaction'><FontAwesomeIcon icon={faCircleCheck} /></button>
                                        <button className='red_sheetaction'><FontAwesomeIcon icon={faXmark} /></button>
                                    </div>
                                </td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td>40.00</td>
                            </tr>

                            <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start'>
                                    Total
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>0.00</td>
                                <td>15.00</td>
                                <td>15.00</td>
                                <td>14.00</td>
                                <td>17.00</td>
                                <td>16.00</td>
                                <td>0.00</td>
                                <td>77.00</td>
                            </tr>

                            <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start'>
                                    Over Time
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>0.00</td>
                                <td>07.00</td>
                                <td>07.00</td>
                                <td>06.00</td>
                                <td>09.00</td>
                                <td>08.00</td>
                                <td>0.00</td>
                                <td>40.00</td>
                            </tr>
                        </tbody>
                    </table>
                </Grid>
            </Grid>
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body>
                <Grid size={{xs:12}} container flexDirection="column" className="regiter_inputs i94validateinput">
                    <span className='mt-0'>Reason for rejection</span>
                    <textarea placeholder='Write points' className='sheet_resontextarea'/>
                    <Grid size={{xs:12}} container justifyContent="flex-end" className="gap-3">
                        <button className='registersendbtn1 mb-2' onClick={handleClose}>
                            Cancel
                        </button>
                        <button className='registersendbtn2 mb-2'>Submit</button>
                    </Grid>
                </Grid>
                </Modal.Body>
            </Modal>
            <Modal
                show={showApprove}
                onHide={handleCloseApprove}
                size="md"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body>
                    <Grid size={{xs:12}} container>
                        <Grid size={{xs:12}} container flexDirection="column" alignItems="center" className="approve_mainsheetmodal">
                            <FontAwesomeIcon className='approve_icon mb-3' icon={faCircleCheck} />
                            <h4>Approve Timesheet</h4>
                            <span>are you sure want to approve this timesheet</span>
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="center" className="gap-3 approve_mainsheetmodal">
                            <button className='registersendbtn1 mb-2' onClick={handleCloseApprove}>
                                No
                            </button>
                            <button className='registersendbtn2 mb-2'>Yes</button>
                        </Grid>
                    </Grid>
                </Modal.Body>
            </Modal>
        </div>
    </div>
  );
}

export default ApproveProjectTimesheet;